type MarkerAnimatedIcon = {
  markerColor: string;
  strokeColor: string;
};

function MarkerAnimatedIcon(props: MarkerAnimatedIcon): JSX.Element {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="10" fill={props.strokeColor} opacity="0.5">
        <animate attributeName="r" from="10" to="20" dur="1.5s" repeatCount="indefinite" />
        <animate attributeName="opacity" from="1.0" to="0.0" dur="1.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="20" cy="20" r="10" fill={props.markerColor} />
    </svg>
  );
}

export default MarkerAnimatedIcon;
